module.exports = __webpack_public_path__ + "img/chevron_black_left.f334187d.png";